module.exports = __webpack_public_path__ + "img/4.26c3562b.png";